"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var messages_1 = require("./messages");
var getType_1 = require("../../helper/getType");
var utils_1 = require("../../helper/utils");
var types = require("../index");
var ObjectType = {
    type: function (errorMsg, options) {
        if (options === void 0) { options = { objectOf: {} }; }
        return function (target) {
            if (!utils_1.isObject(target)) {
                return { message: errorMsg } || { message: messages_1.default.object };
            }
            if (options.objectOf === undefined) {
                return false;
            }
            var isAllRight = Object.keys(options.objectOf).every(function (key) {
                var fieldSchmea = options.objectOf[key];
                var fieldType = fieldSchmea.type;
                if (!fieldType) {
                    fieldType = fieldSchmea;
                }
                var _a = getType_1.default(fieldType), typeName = _a[0], childtypeOptions = _a[1];
                return types.supportTypeValidate[utils_1.captitalize(typeName)].type(errorMsg, childtypeOptions)(target[key]) === false;
            });
            if (isAllRight) {
                return false;
            }
            return { message: errorMsg } || { message: messages_1.default.object };
        };
    }
};
exports.default = ObjectType;



//////////////////
// WEBPACK FOOTER
// ../node_modules/kya/dist/type/object/index.js
// module id = 325
// module chunks = 0